import type { AssetLibraryPreferences } from './assetLibraryPreferences';

const folderKey = (companyId: string, scope: string) => `ael.assetLibrary.lastFolder.${companyId}.${scope}`;

/** Guarded: reading `localStorage` throws outright in Safari's private mode. */
const read = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const write = (key: string, value: string): void => {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // The library works, it just forgets.
  }
};

export const localStorageAssetLibraryPreferences: AssetLibraryPreferences = {
  getLastFolder: (companyId, scope) => read(folderKey(companyId, scope)),

  setLastFolder: (companyId, scope, folderId) => write(folderKey(companyId, scope), folderId),
};
